<template>
  <div class="microclass">
    <!-- 视频区域 -->
    <div class="microclass-center">
      <div class="microclass-videobox">
        <div
          class="video-box"
          v-for="(item,index) in activitydata"
          :key="index"
          @click="btnSubmit(item.id)"
        >
          <img :src="item.imgUrl" />
          <div class="video-box-footer">
            <div class="microclass-text-right">{{item.name}}</div>

            <div class="microclass-msg">
              <div class="microclass-text-left">{{item.title}}进行中</div>
              <span class="microclass-msg-left">{{item.deptName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as personcen from '@/api/personcenter/index.js';
export default {
  data() {
    return {
      activitydata: '',
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    getlist() {
      personcen.LoadActivityInfo(this.listQuery).then((res) => {
        this.activitydata = res.data;
        res.data.forEach((element, index) => {
          let star = element.beginTime.slice(0, 10);
          this.activitydata[index].beginTime = star;
          let end = element.endTime.slice(0, 10);
          this.activitydata[index].endTime = end;
        });
        // this.listQuery.count=res.count
      });
    },
    btnSubmit(id) {
      this.$router.push({
        path: '/mooc/moocAppraise',
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.microclass-center {
  width: 1200px;
  padding: 20px 0 30px 0;
  background: #ffffff;
  .microclass-videobox {
    display: flex;
    flex-wrap: wrap;
    // align-content: flex-start;
    .video-box {
      width: 228px;
      border: 1px solid #f2f2f2;
      margin: 0 5px 20px 5px;
      border-radius: 6px;
      > img {
        width: 100%;
        height: 136px;
        border-radius: 6px 6px 0 0;
        cursor: pointer;
      }
      // img:hover {
      //   transform: scale(1.02);
      //   box-shadow: 3px 3px 10px rgb(170 170 170 / 100%);
      // }
      .video-box-footer {
        margin-top: 6px;
        .microclass-text-right {
          font-size: 16px;
          font-family: Source Han Sans CN;
          opacity: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 10px;
          overflow: hidden;
          cursor: pointer;
        }

        .microclass-msg {
          padding: 10px;
          display: flex;
          .microclass-text-left {
            padding: 0 5px;
            border: 1px solid #4876c4;
            color: #4876c4;
            border-radius: 4px;
            font-size: 13px;
            font-family: Source Han Sans CN;
            line-height: 20px;
            text-align: center;
          }
          .microclass-msg-left {
            flex: 1;
            font-size: 14px;
            font-family: Source Han Sans CN;
            line-height: 20px;
            color: #999999;
            text-align: right;
          }
        }
      }
    }
  }
}
.video-box:hover {
  transform: scale(1.02);
  cursor: pointer;
  box-shadow: 1px 1px 5px rgb(156, 154, 154, 0.996);
}
</style>